'use strict';

/**
 * @param {Object} object
 * @returns {Object}
 */
export default function unflatten(object) {
    const result = {};
    Object.keys(object || {}).forEach(function (key) {
        const value = object[key];
        const parts = key.split('.');
        let target = result;
        parts.forEach(function (part, index) {
            if (index === parts.length - 1) {
                target[part] = value;
            } else {
                if (target[part] == null || typeof target[part] !== 'object') {
                    target[part] = {};
                }
                target = target[part];
            }
        });
    });
    return result;
}
